var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ebbly-info" }, [
    _c("div", { staticClass: "row-line" }, [
      _c("div", {
        directives: [
          {
            name: "lazy",
            rawName: "v-lazy:background-image",
            value: _vm.inviteImg,
            expression: "inviteImg",
            arg: "background-image"
          }
        ],
        staticClass: "row-line-item bg-lazy",
        staticStyle: { cursor: "pointer" },
        on: { click: _vm.jump }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row-line-item download-bg" }, [
        _c("div", {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy:background-image",
              value: require("../../../assets/ebbly-app.png"),
              expression: "require('../../../assets/ebbly-app.png')",
              arg: "background-image"
            }
          ],
          staticClass: "ebbly-app-img"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "download-content" }, [
          _c("h3", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("download_ebbly")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("ebbly_intro")))
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                staticClass: "store-img-link",
                attrs: {
                  href:
                    "https://apps.apple.com/cn/app/iapp-best-travel-companion/id1332627856",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: require("../../../assets/app_badge_apple.png"),
                      expression:
                        "require('../../../assets/app_badge_apple.png')"
                    }
                  ],
                  staticClass: "store-img"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "store-img-link",
                attrs: {
                  href:
                    "https://play.google.com/store/apps/details?id=com.ifreegroup.ebbly",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: require("../../../assets/app_badge_google.png"),
                      expression:
                        "require('../../../assets/app_badge_google.png')"
                    }
                  ],
                  staticClass: "store-img"
                })
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "about-list" }, [
      _c("li", { staticClass: "list-item" }, [
        _c("div", { staticClass: "list-item-title" }, [
          _c("span", { staticClass: "icon-chat" }),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("quick_answer")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "list-item-text" }, [
          _vm._v(_vm._s(_vm.$t("quick_answer_content")))
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-item" }, [
        _c("div", { staticClass: "list-item-title" }, [
          _c("span", { staticClass: "icon-secure" }),
          _vm._v(
            "\n                " + _vm._s(_vm.$t("secure")) + "\n            "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "list-item-text" }, [
          _vm._v(_vm._s(_vm.$t("secure_content")))
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-item" }, [
        _c("div", { staticClass: "list-item-title" }, [
          _c("span", { staticClass: "icon-deals" }),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("curated_deals")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "list-item-text" }, [
          _vm._v(_vm._s(_vm.$t("curated_deals_content")))
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-item" }, [
        _c("div", { staticClass: "list-item-title" }, [
          _c("span", { staticClass: "icon-free-data" }),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("free_data")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "list-item-text" }, [
          _vm._v(_vm._s(_vm.$t("free_data_content")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8ad4f1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8ad4f1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/EbblyInfo.vue
// module id = null
// module chunks = 